import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LookupService } from 'src/app/Services/Common/lookup.service';
import { HrService } from 'src/app/services/hr/hr.service';

@Component({
  selector: 'app-staff-time-attendance',
  templateUrl: './staff-time-attendance.component.html',
  styleUrls: ['./staff-time-attendance.component.css']
})
export class StaffTimeAttendanceComponent implements OnInit {
  Submitted: boolean = false;
  StaffAttendanceView = [];

  PrimaryDepartmentList = [];
  YearList = [];
  MonthlyAttendance = [];
  LeaveTypeList = [];

  constructor(private payrollService: HrService, private lookupservice: LookupService, public globalHelper: GlobalHelper,
    private spinnerService: Ng4LoadingSpinnerService) { }

  StaffMonthlyAttendanceModel = {
    MonthID: 0,
    StaffID: 0,
    PrimaryDepartmentID: 0,
  }


  SaveStaffMonthWiseAttendance() {
    this.Submitted = true;
    if (!this.FieldValidation()) {
      this.Submitted = false;
      this.spinnerService.show();

      this.payrollService.SaveStaffMonthWiseAttendance(JSON.stringify(this.StaffAttendanceView), JSON.stringify(this.StaffMonthlyAttendanceModel)).subscribe((data: any) => {
        this.globalHelper.CheckActionStatus(data);

        this.spinnerService.hide();
        if (data.webResponse.Status)
          this.GetStaffMonthWiseAttendance();

      });
    }

  };


  FieldValidation() {

    return this.StaffMonthlyAttendanceModel.MonthID == 0 || this.StaffMonthlyAttendanceModel.StaffID == 0;
  }
  SelectCardNumber(){
    
  }
  ClearList(){
    this.StaffAttendanceView=[];
  }
  GetStaffMonthWiseAttendance() {
 
    this.Submitted = true
    if (!this.FieldValidation()) {
      this.Submitted = false;
      this.spinnerService.show();

      this.payrollService.GetStaffMonthWiseAttendance(JSON.stringify(this.StaffMonthlyAttendanceModel)).subscribe((data: any) => {
        this.StaffAttendanceView = data.StaffAttendanceView;
        if (this.StaffAttendanceView != null && this.StaffAttendanceView.length > 0) {

        }
        this.spinnerService.hide();
      });
    }
  };



  GetDepartment() {
    this.lookupservice.GetLookupsList('Department', '').subscribe((data: any) => {
      this.PrimaryDepartmentList = data.LookupItems;
    });
  };
  SalaryMonthList = [];
  GetSalaryMonth() {
    this.lookupservice.GetLookupsList('SalaryMonth', '').subscribe((data: any) => {
      this.SalaryMonthList = data.LookupItems;
      
    });
  };

  EmployeeList = [];
  GetEmployee() {
    this.StaffMonthlyAttendanceModel.StaffID = 0;
    this.ClearList();
   
    this.lookupservice.GetLookupsList('EmployeeCode', '').subscribe((data: any) => {
      this.EmployeeList = data.LookupItems;
    });
  };


  GetLeaveType() {

    this.lookupservice.GetLookupsList('LeaveType', '').subscribe((data: any) => {
      this.LeaveTypeList = data.LookupItems;
      this.LeaveTypeList.splice(0, 1);
    });
  };

  ngOnInit() {

    this.GetDepartment();
    this.GetLeaveType();
    this.GetSalaryMonth();
    this.GetEmployee();

  }

  // Download

  FilePath: any
  MonthlyAttendanceDownload() {
      this.Submitted = true;
      if (!this.FieldValidation()) {
          this.spinnerService.show();
          
          this.payrollService.MonthlyAttendanceDownload(JSON.stringify(this.StaffMonthlyAttendanceModel)).subscribe((data: any) => {
              this.spinnerService.hide();
              this.Submitted = false;
              this.FilePath = data.FilePath;
              if (data.webResponse != null)
                  if (data.FilePath != null)
                      window.location = data.FilePath;

          });
      }

  };

  // Print


  MonthlyAttendancePrint() {
      this.Submitted = true;
      if (!this.FieldValidation()) {
          this.spinnerService.show();
          var url = "MonthWiseAttendancePrint?PrimaryDepartmentID=" + this.StaffMonthlyAttendanceModel.PrimaryDepartmentID + '&MonthID=' + this.StaffMonthlyAttendanceModel.MonthID + '&StaffID=' + this.StaffMonthlyAttendanceModel.StaffID;
          this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
          this.spinnerService.hide();
          this.Submitted = false;
      };
  }

  
}
